<template>
  <div class="schedule">
    <HeroBanner :title="'Schedule Consultation'"/>
    <div class="wrap">
      <div class="schedule__intro">
        <h2>Step 1:</h2>
        <p>Launch the scheduler to pick a date and time</p>
        <button
          :data-appointlet-organization="'portland-patent'"
          :data-appointlet-email="userEmail"
          :data-appointlet-field-first-name="userFirstName"
          :data-appointlet-field-last-name="userLastName"
          :data-appointlet-field-phone-number="userPhone"
          @mouseup="scheduleClick"
          >
          Launch Scheduler
        </button>
      </div>
      <div class="schedule__complete">
        <h2>Step 2:</h2>
        <p>When you're finished, mark as complete</p>
        <button @click="markScheduled">Mark Complete</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import HeroBanner from '@/components/HeroBanner'
import router from '@/router'
import * as fb from '@/library/firebase'

export default {
  name: 'Schedule',
  components: {
    HeroBanner
  },
  computed: {
    ...mapState([
      'adminEmail',
      'userProfile'
    ]),
    ...mapGetters([
      'currentUserProfile'
    ]),
    userEmail() {
      return this.userProfile?.email || ''
    },
    userFirstName() {
      return this.userProfile?.firstName || ''
    },
    userLastName() {
      return this.userProfile?.lastName || ''
    },
    userPhone() {
      return this.userProfile?.phone || ''
    },
  },
  data() {
    return {
      clickedSchedule: false
    }
  },
  mounted() {
    let appointletScript = document.createElement('script')
    appointletScript.setAttribute('src','//www.appointletcdn.com/loader/loader.min.js')
    document.head.appendChild(appointletScript)
  },
  methods: {
    ...mapActions([
      'setTimelineStep'
    ]),
    scheduleClick() {
      setTimeout(() => {
        this.clickedSchedule = true
      }, 5000)
    },
    async markScheduled() {
      const sendEmail = fb.funcs.httpsCallable('sendEmail')
      const to = this.adminEmail
      const subject = `CONFLICT CHECK - Request for PortlandPatent User ${this.currentUserProfile.firstName} ${this.currentUserProfile.lastName}`
      let message = '<p>PLEASE RUN A CONFLICT CHECK USING AT LEAST THE FOLLOWING INFORMATION:</p>'
      message += '<table>'
      message += `<tr><td>First name</td><td>${this.currentUserProfile.firstName}</td></tr>`
      message += `<tr><td>Last name</td><td>${this.currentUserProfile.lastName}</td></tr>`
      message += `<tr><td>Business name</td><td>${this.currentUserProfile.businessName}</td></tr>`
      message += `<tr><td>Phone</td><td>${this.currentUserProfile.phone}</td></tr>`
      message += `<tr><td>Address 1</td><td>${this.currentUserProfile.address1}<td></tr>`
      message += `<tr><td>Address 2</td><td>${this.currentUserProfile.address2}</td></tr>`
      message += `<tr><td>City/State/Zip</td><td>${this.currentUserProfile.city}, ${this.currentUserProfile.state} ${this.currentUserProfile.zip}</td></tr>`
      message += `<tr><td>E-mail</td><td>${this.currentUserProfile.email}</td></tr>`
      message += `<tr><td>Competitors</td><td>${this.currentUserProfile.competitors}</td></tr>`
      message += `<tr><td>Certification 1</td><td>${this.currentUserProfile.certification1}</td></tr>`
      message += `<tr><td>Certification 2</td><td>${this.currentUserProfile.certification2}</td></tr>`
      message += `</table>`
      // First name, last name, business name, business entity, telephone, address, email, adverse parties, prior disclosure}
      await sendEmail({ to, subject, message }).catch((error) => {
        this.pending = false
        this.$notify({
          duration: 10000,
          group: 'default',
          title: 'Error',
          type: 'error',
          text: error
        })
      })
      this.setTimelineStep(1)
      router.push('/').catch(() => {})
    }
  }
}
</script>

<style scoped lang="scss">
.schedule {
  .wrap {
    display: flex;
    justify-content: center;
    padding: 2rem;
    > div {
      display: block;
      text-align: center;
      margin: 20px 0;
      width: 100%;
    }

  }

}
button {
  display: block;
  @include btn-secondary;
  margin: 4rem auto;
}
</style>